import { CalendarMonthOutlined } from '@mui/icons-material'
import { Chip, ChipProps } from '@mui/material'
import { isFuture, isPast } from 'date-fns'
import { useTranslation } from 'react-i18next'

export const TrackingsTimespanFilterChip: React.FC<{
    from?: Date
    to?: Date
    onDelete?: ChipProps['onDelete']
}> = ({
    from,
    to,

    onDelete,
}) => {
    const { t } = useTranslation()

    const label =
        from && to ? t('trackings.filters.fromTo', { from, to })
        : from && !to ?
            isFuture(from) ? t('trackings.filters.fromInFuture', { from })
            :   t('trackings.filters.fromUntilToday', { from })
        : !from && to ?
            isPast(to) ? t('trackings.filters.toInPast', { to })
            :   t('trackings.filters.todayUntilTo', { to })
        :   undefined

    return (
        <Chip
            icon={<CalendarMonthOutlined fontSize={'small'} />}
            label={label}
            onDelete={onDelete}
        />
    )
}
